import * as React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import { TipWrapper } from '.';

const paths = {
  tipSettings: '/settings/tipping',
};

export default [
  <RouteIfRights
    exact
    path={paths.tipSettings}
    key={paths.tipSettings}
    component={TipWrapper}
    rights="admin"
    modules="register.sales.tip"
  />,
];

export { paths };
